/* ══════════════════════════════════════════════════════════════════════════
   Doodle Sneaks — theme behaviour.
   Vanilla JS, no build step. Cart runs through Shopify's AJAX Cart API and
   the Section Rendering API; search runs through Predictive Search.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.DoodleTheme || {};
  var routes = cfg.routes || {};
  var moneyFormat = cfg.moneyFormat || '${{amount}}';

  /* ── helpers ─────────────────────────────────────────────────────── */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (typeof cents === 'string') ? parseFloat(cents.replace(/[^0-9.-]/g, '')) * 100 : cents;
    if (isNaN(value)) return '';
    function group(num, decimals, thousands, decimal) {
      num = (num / 100).toFixed(decimals);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var out = moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        default: return '';
      }
    });
    return out.replace(/<[^>]*>/g, '');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function lockScroll(on) {
    root.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }

  /* ── cart ────────────────────────────────────────────────────────── */

  var Cart = {
    drawer: null,
    backdrop: null,
    lastFocus: null,

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      this.backdrop = $('[data-cart-backdrop]');
      if (!this.drawer) return;

      var self = this;

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-cart-open]');
        if (openBtn) { e.preventDefault(); self.open(); return; }

        if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) {
          e.preventDefault(); self.close(); return;
        }

        var change = e.target.closest('[data-cart-change]');
        if (change) {
          e.preventDefault();
          self.change(
            change.getAttribute('data-line'),
            change.getAttribute('data-qty'),
            self.drawer.contains(change)
          );
          return;
        }

        var add = e.target.closest('[data-quick-add]');
        if (add) {
          e.preventDefault(); e.stopPropagation();
          self.quickAdd(add);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) self.close();
      });
    },

    isOpen: function () { return this.drawer && this.drawer.classList.contains('is-open'); },

    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.removeAttribute('aria-hidden');
      if (this.backdrop) this.backdrop.classList.add('is-open');
      lockScroll(true);
      var focusable = $('[data-cart-close]', this.drawer);
      if (focusable) focusable.focus();
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.backdrop) this.backdrop.classList.remove('is-open');
      lockScroll(false);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    busy: function (on) {
      if (this.drawer) this.drawer.classList.toggle('is-busy', !!on);
    },

    refresh: function () {
      var self = this;
      return fetch((routes.root || '/') + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-body]', doc);
          var body = $('[data-cart-body]', self.drawer);
          if (fresh && body) body.innerHTML = fresh.innerHTML;
          var count = $('[data-cart-drawer-count]', doc);
          var target = $('[data-cart-drawer-count]', self.drawer);
          if (count && target) target.textContent = count.textContent;
          if (fresh) self.setCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
        })
        .catch(function () { /* leave the drawer as-is on a network hiccup */ });
    },

    setCount: function (n) {
      if (isNaN(n)) return;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    },

    change: function (line, qty, inDrawer) {
      var self = this;
      this.busy(true);
      return fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.setCount(cart.item_count);
          if (inDrawer === false) { window.location.reload(); return; }
          return self.refresh();
        })
        .finally(function () { self.busy(false); });
    },

    add: function (id, quantity) {
      var self = this;
      return fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Add to cart failed');
          return body;
        });
      }).then(function (body) {
        return self.refresh().then(function () { self.open(); return body; });
      });
    },

    quickAdd: function (btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      var self = this;
      btn.classList.add('is-busy');
      btn.disabled = true;
      this.add(id, 1)
        .catch(function (err) { window.alert(err.message); })
        .finally(function () {
          btn.classList.remove('is-busy');
          btn.disabled = false;
          self.busy(false);
        });
    }
  };

  /* ── search overlay ──────────────────────────────────────────────── */

  var Search = {
    overlay: null,
    input: null,
    grid: null,
    count: null,
    all: null,
    lastFocus: null,

    init: function () {
      this.overlay = $('[data-search-overlay]');
      if (!this.overlay) return;
      this.input = $('[data-search-input]', this.overlay);
      this.grid = $('[data-search-results]', this.overlay);
      this.count = $('[data-search-count]', this.overlay);
      this.all = $('[data-search-all]', this.overlay);

      var self = this;

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-search-open]')) { e.preventDefault(); self.open(); return; }
        if (e.target.closest('[data-search-close]')) { e.preventDefault(); self.close(); }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.overlay.classList.contains('is-open')) self.close();
      });

      this.input.addEventListener('input', debounce(function () { self.query(self.input.value); }, 220));
      var form = $('[data-search-form]', this.overlay);
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!self.input.value.trim()) e.preventDefault();
        });
      }
    },

    open: function () {
      this.lastFocus = document.activeElement;
      this.overlay.classList.add('is-open');
      this.overlay.removeAttribute('aria-hidden');
      lockScroll(true);
      var self = this;
      setTimeout(function () { self.input.focus(); self.input.select(); }, 80);
    },

    close: function () {
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    query: function (term) {
      var q = (term || '').trim();
      var self = this;
      if (this.all) this.all.hidden = !q;
      if (this.all && q) {
        this.all.href = (routes.search || '/search') + '?q=' + encodeURIComponent(q);
        this.all.textContent = 'See all results for “' + q + '” →';
      }
      if (!q) {
        this.grid.innerHTML = '';
        this.count.textContent = '';
        return;
      }
      var url = (routes.predictiveSearch || '/search/suggest.json')
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=10'
        + '&resources[options][unavailable_products]=last';

      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          self.count.textContent = products.length + (products.length === 1 ? ' result' : ' results');
          self.grid.innerHTML = products.map(function (p) { return self.card(p); }).join('');
          if (!products.length) {
            self.grid.innerHTML = '<p class="empty-state__title" style="grid-column:1/-1">Nothing matches that sniff.</p>';
          }
        })
        .catch(function () {
          self.count.textContent = '';
          self.grid.innerHTML = '';
        });
    },

    card: function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      var price = formatMoney(p.price);
      var media = img
        ? '<img class="pcard__img" src="' + escapeHtml(img) + '&width=500" alt="' + escapeHtml(p.title) + '" loading="lazy">'
        : '<svg class="pcard__placeholder" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/></svg>';
      return '<a class="pcard" href="' + escapeHtml(p.url) + '">'
        + '<div class="pcard__tile">' + media + '</div>'
        + '<div class="pcard__body"><div class="pcard__title">' + escapeHtml(p.title) + '</div>'
        + '<div class="pcard__price">' + price + '</div></div></a>';
    }
  };

  /* ── rails ───────────────────────────────────────────────────────── */

  function initRails() {
    $$('[data-rail-prev], [data-rail-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-rail-wrap]');
        var rail = wrap && $('[data-rail]', wrap);
        if (!rail) return;
        var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * 660, behavior: 'smooth' });
      });
    });
  }

  /* ── product detail ──────────────────────────────────────────────── */

  function initProduct() {
    var form = $('[data-product-form]');
    if (!form) return;

    var sizeButtons = $$('[data-size]', form);
    var variantInput = $('[data-variant-input]', form);
    var submit = $('[data-atc]', form);
    var warn = $('[data-size-warn]', form);
    var priceEl = $('[data-variant-price]');
    var defaultLabel = submit ? submit.innerHTML : '';
    var addedTimer;

    function select(btn) {
      sizeButtons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      variantInput.value = btn.getAttribute('data-variant-id');
      if (warn) warn.hidden = true;
      if (priceEl && btn.getAttribute('data-price')) {
        priceEl.innerHTML = btn.getAttribute('data-price');
      }
      if (submit) {
        var available = btn.getAttribute('data-available') === 'true';
        submit.disabled = !available;
        submit.classList.toggle('btn-primary', available);
        submit.classList.toggle('btn-secondary', !available);
        submit.innerHTML = available ? defaultLabel : (cfg.strings.soldOut || 'Sold out');
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers: skip the URL sync */ }
    }

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    if (sizeButtons.length === 1) select(sizeButtons[0]);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput.value) {
        if (warn) warn.hidden = false;
        return;
      }
      if (submit.disabled) return;
      submit.disabled = true;
      Cart.add(variantInput.value, 1)
        .then(function () {
          submit.classList.remove('btn-primary');
          submit.classList.add('atc--added');
          submit.innerHTML = cfg.strings.inCart || 'In the cart';
          clearTimeout(addedTimer);
          addedTimer = setTimeout(function () {
            submit.classList.remove('atc--added');
            submit.classList.add('btn-primary');
            submit.innerHTML = defaultLabel;
          }, 1800);
        })
        .catch(function (err) { window.alert(err.message); })
        .finally(function () { submit.disabled = false; Cart.busy(false); });
    });

    // gallery
    var stage = $('[data-gallery-stage]');
    if (stage) {
      $$('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.getAttribute('data-thumb');
          $$('[data-thumb]').forEach(function (t) {
            t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
          });
          $$('[data-stage-image]', stage).forEach(function (img) {
            img.hidden = img.getAttribute('data-stage-image') !== index;
          });
        });
      });
    }
  }

  /* ── catalog: chips + sort over the whole collection ─────────────── */

  function initCatalog() {
    var section = $('[data-catalog]');
    if (!section) return;

    var grid = $('[data-catalog-grid]', section);
    var countEl = $('[data-catalog-count]', section);
    var sortSelect = $('[data-catalog-sort]', section);
    var emptyEl = $('[data-catalog-empty]', section);
    var paginationEl = $('[data-catalog-pagination]', section);
    var totalPages = parseInt(section.getAttribute('data-pages') || '1', 10);
    var currentPage = parseInt(section.getAttribute('data-page') || '1', 10);
    var total = parseInt(section.getAttribute('data-total') || '0', 10);
    var MAX_PAGES = 6; // ~300 products; beyond that we leave native pagination in place
    var sizeSelect = $('[data-catalog-size]', section);
    var state = { brand: 'All', dept: 'All', size: 'All', sort: (sortSelect && sortSelect.value) || 'manual' };

    function cards() { return $$('.pcard[data-vendor]', grid); }

    function labelFor(variants) {
      // Vendors arrive with inconsistent casing (Nike / NIKE / nike).
      // Prefer a mixed-case spelling, then the most common one.
      var mixed = variants.filter(function (v) { return v !== v.toUpperCase() && v !== v.toLowerCase(); });
      return (mixed[0] || variants[0]);
    }

    function buildChips() {
      var brandRow = $('[data-brand-chips]', section);
      var deptRow = $('[data-dept-chips]', section);
      if (!brandRow || !deptRow) return;

      var brands = {}, depts = {};
      cards().forEach(function (card) {
        var v = card.getAttribute('data-vendor') || '';
        var key = v.toLowerCase();
        if (key) { (brands[key] = brands[key] || []).push(v); }
        var d = card.getAttribute('data-dept') || '';
        if (d) { depts[d] = (depts[d] || 0) + 1; }
      });

      function chip(label, value, group, sage) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip' + (sage ? ' chip--sage' : '');
        b.textContent = label;
        b.setAttribute('data-filter', group);
        b.setAttribute('data-value', value);
        b.setAttribute('aria-pressed', state[group] === value ? 'true' : 'false');
        return b;
      }

      brandRow.innerHTML = '';
      brandRow.appendChild(chip('All', 'All', 'brand', false));
      Object.keys(brands).sort().forEach(function (key) {
        brandRow.appendChild(chip(labelFor(brands[key]), key, 'brand', false));
      });

      deptRow.innerHTML = '';
      var deptOrder = ["Men's", "Women's", 'GS', 'PS', 'TD', 'Kids', 'Unisex'];
      var deptKeys = Object.keys(depts).sort(function (a, b) {
        var ia = deptOrder.indexOf(a), ib = deptOrder.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      if (deptKeys.length > 1) {
        deptRow.appendChild(chip('All', 'All', 'dept', true));
        deptKeys.forEach(function (d) { deptRow.appendChild(chip(d, d, 'dept', true)); });
      }
    }

    function cardSizes(card) {
      return (card.getAttribute('data-sizes') || '').split('|').filter(Boolean);
    }

    function buildSizes() {
      if (!sizeSelect) return;

      // Union of in-stock size tokens across every card, bucketed for optgroups.
      var seen = {};
      cards().forEach(function (card) {
        cardSizes(card).forEach(function (t) { seen[t] = true; });
      });

      var groups = {
        mens:   { label: sizeSelect.getAttribute('data-label-mens') || "Men's",   test: /^M(\d+(\.\d+)?)$/,  sizes: [] },
        womens: { label: sizeSelect.getAttribute('data-label-womens') || "Women's", test: /^W(\d+(\.\d+)?)$/,  sizes: [] },
        kids:   { label: sizeSelect.getAttribute('data-label-kids') || 'Big Kids', test: /^(\d+(\.\d+)?)Y$/,  sizes: [] }
      };
      Object.keys(seen).forEach(function (t) {
        for (var g in groups) {
          var m = t.match(groups[g].test);
          if (m) { groups[g].sizes.push({ token: t, n: parseFloat(m[1]) }); return; }
        }
      });

      // Keep the "Any size" option, rebuild the rest.
      while (sizeSelect.options.length > 1) sizeSelect.remove(1);
      ['mens', 'womens', 'kids'].forEach(function (g) {
        var group = groups[g];
        if (!group.sizes.length) return;
        group.sizes.sort(function (a, b) { return a.n - b.n; });
        var og = document.createElement('optgroup');
        og.label = group.label;
        group.sizes.forEach(function (s) {
          var o = document.createElement('option');
          o.value = s.token;
          // "M4" displays as "M 4"; "5Y" stays as-is.
          o.textContent = /Y$/.test(s.token) ? s.token : s.token.replace(/^([MW])/, '$1 ');
          og.appendChild(o);
        });
        sizeSelect.appendChild(og);
      });
      sizeSelect.hidden = false;
    }

    function apply() {
      var shown = 0;
      cards().forEach(function (card) {
        var okBrand = state.brand === 'All' || (card.getAttribute('data-vendor') || '').toLowerCase() === state.brand;
        var okDept = state.dept === 'All' || card.getAttribute('data-dept') === state.dept;
        var okSize = state.size === 'All' || cardSizes(card).indexOf(state.size) !== -1;
        var visible = okBrand && okDept && okSize;
        card.hidden = !visible;
        if (visible) shown++;
      });

      var sorted = cards().slice();
      if (state.sort === 'title-ascending') {
        sorted.sort(function (a, b) {
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        });
      } else if (state.sort === 'price-ascending') {
        sorted.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
      } else if (state.sort === 'price-descending') {
        sorted.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
      } else {
        sorted.sort(function (a, b) { return num(a, 'data-index') - num(b, 'data-index'); });
      }
      sorted.forEach(function (card) { grid.appendChild(card); });

      if (countEl) countEl.textContent = shown + ' of ' + (total || cards().length);
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (grid) grid.hidden = shown === 0;
    }

    function num(el, attr) { return parseFloat(el.getAttribute(attr) || '0'); }

    // Client-side filtering is only honest once the whole collection is in the
    // DOM. Until then (and forever, if hydration fails) the server-rendered
    // links and native sort stay in charge.
    var clientMode = false;

    section.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (!chip || !clientMode) return;
      e.preventDefault();
      var group = chip.getAttribute('data-filter');
      state[group] = chip.getAttribute('data-value');
      $$('[data-filter="' + group + '"]', section).forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-value') === state[group] ? 'true' : 'false');
      });
      writeUrlFilters();
      apply();
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        if (!clientMode) { sortSelect.form.submit(); return; } // native ?sort_by=
        state.sort = sortSelect.value;
        apply();
      });
    }

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        if (!clientMode) return; // select stays hidden pre-hydration anyway
        state.size = sizeSelect.value;
        writeUrlFilters();
        apply();
      });
    }

    var reset = $('[data-catalog-reset]', section);
    if (reset) {
      reset.addEventListener('click', function () {
        if (!clientMode) { window.location.href = window.location.pathname; return; }
        state.brand = 'All'; state.dept = 'All'; state.size = 'All'; state.sort = 'manual';
        if (sortSelect) sortSelect.value = 'manual';
        if (sizeSelect) sizeSelect.value = 'All';
        $$('[data-filter]', section).forEach(function (c) {
          c.setAttribute('aria-pressed', c.getAttribute('data-value') === 'All' ? 'true' : 'false');
        });
        writeUrlFilters();
        apply();
      });
    }

    // Pull the remaining pages in as real, Liquid-rendered cards so the chips
    // filter the whole collection rather than just page one.
    //
    // This fetches each page as HTML rather than through the Section Rendering
    // API: `?sections=` 404s on the /collections/all route, so the API is not
    // dependable for the catalog. Pagination stays visible unless every page
    // actually landed — a partial hydrate must never strand anyone on page 1.
    function readUrlFilters() {
      try {
        var params = new URL(window.location.href).searchParams;
        var sz = params.get('size');
        if (sz) state.size = String(sz).replace(/\s+/g, '');
        var dept = params.get('dept');
        if (dept) state.dept = dept;
      } catch (e) { /* ignore bad URLs */ }
    }

    function writeUrlFilters() {
      try {
        var url = new URL(window.location.href);
        if (state.size && state.size !== 'All') url.searchParams.set('size', state.size);
        else url.searchParams.delete('size');
        if (state.dept && state.dept !== 'All') url.searchParams.set('dept', state.dept);
        else url.searchParams.delete('dept');
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    function goClient() {
      clientMode = true;
      if (paginationEl) paginationEl.hidden = true;
      readUrlFilters();
      buildChips();
      buildSizes();
      if (sizeSelect) sizeSelect.value = state.size;
      apply();
    }

    function hydrate() {
      // Single page: everything is already here.
      if (totalPages <= 1) { goClient(); return; }
      // Too big to hold in the DOM — leave native pagination and links alone.
      if (totalPages > MAX_PAGES) return;

      var base = window.location.pathname;
      var search = window.location.search.replace(/[?&]page=\d+/, '').replace(/^&/, '?');
      var jobs = [];
      for (var p = 1; p <= totalPages; p++) {
        if (p === currentPage) continue; // already server-rendered below us
        var url = base + (search ? search + '&' : '?') + 'page=' + p;
        jobs.push(
          fetch(url, { headers: { 'Accept': 'text/html' } })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; })
        );
      }

      Promise.all(jobs).then(function (pages) {
        var fetched = [];
        var complete = true;
        pages.forEach(function (html) {
          if (!html) { complete = false; return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = $$('.pcard[data-vendor]', doc);
          if (!found.length) { complete = false; return; }
          found.forEach(function (card) { fetched.push(card); });
        });

        // A partial catalog would make the chips and the "N of 75" count lie,
        // and hiding pagination would strand shoppers on page one. Only switch
        // to client-side filtering when every page actually arrived.
        if (!complete) return;

        fetched.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
        goClient();
      });
    }

    hydrate();
  }

  /* ── newsletter + contact form success states ────────────────────── */

  function initForms() {
    // Shopify posts back with ?customer_posted=true / ?contact_posted=true and
    // an anchor; scroll the relevant panel into view.
    var target = $('[data-form-success]');
    if (target) {
      setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
    }
  }

  /* ── mobile menu ─────────────────────────────────────────────────── */

  function initMenu() {
    var btn = $('[data-menu-toggle]');
    var drawer = $('[data-menu-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!drawer.contains(e.target) && !btn.contains(e.target)) {
        drawer.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── boot ────────────────────────────────────────────────────────── */

  function boot() {
    Cart.init();
    Search.init();
    initRails();
    initProduct();
    initCatalog();
    initForms();
    initMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.DoodleTheme = Object.assign(cfg, { cart: Cart, search: Search, formatMoney: formatMoney });
})();
